import {SagaIterator} from 'redux-saga';
import {all, call, takeEvery} from 'redux-saga/effects';
import {
  CANCEL_APPOINTMENT_START,
  EXPORT_APPOINTMENTS_CSV_START,
  EXPORT_APPOINTMENTS_ASYNC_START,
  FETCH_ALL_APPOINTMENTS_START,
  FETCH_PAGINATED_CLIENTS_START,
  FETCH_PAGINATED_PROVIDERS_START,
  FETCH_PROVIDER_AVAILABILITY_START,
  SCHEDULE_APPOINTMENT_START,
  UPDATE_APPOINTMENT_START,
  FETCH_APPOINTMENT_ACTIVITY_LOGS_START,
} from './calendar.constants';
import {
  cancelAppointmentStartSaga,
  exportAppointmentsCsvSaga,
  exportAppointmentsAsyncSaga,
  fetchAllAppointmentsStartSaga,
  fetchPaginatedClientsStartSaga,
  fetchPaginatedProvidersSaga,
  fetchProviderAvailabilityStartSaga,
  scheduleAppointmentStartSaga,
  updateAppointmentStartSaga,
  fetchAppointmentActivityLogsStartSaga,
} from './calendar.sagas';

export function* onFetchProviderAvailabilityStart(): SagaIterator<void> {
  yield takeEvery(
    FETCH_PROVIDER_AVAILABILITY_START,
    fetchProviderAvailabilityStartSaga,
  );
}

export function* onFetchPaginatedProvidersStart(): SagaIterator<void> {
  yield takeEvery(FETCH_PAGINATED_PROVIDERS_START, fetchPaginatedProvidersSaga);
}

// Fetch all appointments
export function* onFetchAllAppointmentsStart(): SagaIterator<void> {
  yield takeEvery(FETCH_ALL_APPOINTMENTS_START, fetchAllAppointmentsStartSaga);
}

// Schedule Appointment
export function* onScheduleAppointmentStart(): SagaIterator<void> {
  yield takeEvery(SCHEDULE_APPOINTMENT_START, scheduleAppointmentStartSaga);
}

// Cancel Appointment
export function* onCancelAppointmentStart(): SagaIterator<void> {
  yield takeEvery(CANCEL_APPOINTMENT_START, cancelAppointmentStartSaga);
}

// Update Appointment
export function* onUpdateAppointmentStart(): SagaIterator<void> {
  yield takeEvery(UPDATE_APPOINTMENT_START, updateAppointmentStartSaga);
}

export function* onExportAppointmentsCsvStart(): SagaIterator<void> {
  yield takeEvery(EXPORT_APPOINTMENTS_CSV_START, exportAppointmentsCsvSaga);
}

export function* onExportAppointmentsAsyncStart(): SagaIterator<void> {
  yield takeEvery(EXPORT_APPOINTMENTS_ASYNC_START, exportAppointmentsAsyncSaga);
}

// fetch paginated clients
export function* onFetchPaginatedClientsStart(): SagaIterator<void> {
  yield takeEvery(
    FETCH_PAGINATED_CLIENTS_START,
    fetchPaginatedClientsStartSaga,
  );
}

export function* onFetchAppointmentActivityLogsStart(): SagaIterator<void> {
  yield takeEvery(
    FETCH_APPOINTMENT_ACTIVITY_LOGS_START,
    fetchAppointmentActivityLogsStartSaga,
  );
}

export function* calendarSagas(): SagaIterator<void> {
  yield all([
    call(onFetchProviderAvailabilityStart),
    call(onFetchPaginatedProvidersStart),
    call(onFetchAllAppointmentsStart),
    call(onScheduleAppointmentStart),
    call(onCancelAppointmentStart),
    call(onUpdateAppointmentStart),
    call(onExportAppointmentsCsvStart),
    call(onExportAppointmentsAsyncStart),
    call(onFetchPaginatedClientsStart),
    call(onFetchAppointmentActivityLogsStart),
  ]);
}
